<template>
  <div class="tree">
    <div class="brand_owner item" v-for="(item, index) in data" :key="index">
      <div class="title c_p" @click="expands(item.Id)">
        <i
          class="icon iconfont icon-sanjiaojiantou-xia tree_expand_icon"
          :style="{
            transform:
              expandArr.indexOf(item.Id) !== -1
                ? 'rotate(0deg)'
                : 'rotate(-90deg)'
          }"
        ></i>
        <span>{{ item.Name }}</span>
      </div>
      <transition name="item">
        <div class="content" v-if="expandArr.indexOf(item.Id) !== -1">
          <div
            class="content_item clear"
            v-for="(items, indexs) in item.Children"
            :key="indexs"
          >
            <div class="content_item_item f_l">
              <input
                type="checkbox"
                :name="item.Code"
                v-model="
                  moduletreeForm.Modules[index].Children[indexs].IsEnabled
                "
                @change="
                  isEnabled(
                    index,
                    indexs,
                    moduletreeForm.Modules[index].Children[indexs].IsEnabled,
                    items.Name
                  )
                "
              />
              <span :title="items.Name">{{ items.Name }}</span>
            </div>
            <template v-if="item.Name !== 'Admin'">
              <template v-if="items.Code === 'MKTBrand' | items.Code === 'SOPBrand'">
                <div class="content_item_item_item f_l clear">
                  <label
                    class="f_l"
                    v-for="(itemss, indexss) in brandList"
                    :key="indexss"
                    ><input
                      type="checkbox"
                      :name="items.Id"
                      :value="brandList[indexss].Code"
                      v-model="
                        moduletreeForm.Modules[index].Children[indexs].BrandCode
                      "
                      @change="
                        isEnabledBrandCode(
                          index,
                          indexs,
                          moduletreeForm.Modules[index].Children[indexs]
                            .BrandCode
                        )
                      "
                    />{{ itemss.CN_Name }}</label
                  >
                </div>
              </template>
              <template v-else-if="items.Name !== 'Report'">
                <div class="content_item_item_item f_l clear">
                  <label class="f_l"
                    ><input
                      type="radio"
                      :name="items.Id"
                      value="1"
                      v-model="moduletreeForm.Modules[index].Children[indexs].Authority"
                      @change="
                        isEnabledAuthority(
                          index,
                          indexs,
                          moduletreeForm.Modules[index].Children[indexs].Authority
                        )
                      "
                    />
                    只读</label
                  >
                  <label class="f_l"
                    ><input
                      type="radio"
                      :name="items.Id"
                      value="2"
                      v-model="moduletreeForm.Modules[index].Children[indexs].Authority"
                      @change="
                        isEnabledAuthority(
                          index,
                          indexs,
                          moduletreeForm.Modules[index].Children[indexs].Authority
                        )
                      "
                    />
                    编辑</label
                  >
                  <input
                    v-show="false"
                    type="radio"
                    :name="items.Id"
                    value="0"
                    v-model="moduletreeForm.Modules[index].Children[indexs].Authority"
                  />
                </div>
              </template>
            </template>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 展开项
      expandArr: []
    }
  },
  methods: {
    expands (id) {
      if (this.expandArr.indexOf(id) === -1) {
        this.expandArr.push(id)
      } else {
        this.expandArr.splice(this.expandArr.indexOf(id), 1)
      }
    },
    isEnabled (index, indexs, IsEnabled, Name) {
      if (IsEnabled) {
        let BrandCode = []
        this.brandList.forEach(item => {
          BrandCode.push(item.Code)
        })
        this.moduletreeForm.Modules[index].Children[indexs].BrandCode = BrandCode
        this.moduletreeForm.Modules[index].Children[indexs].Authority = '1'
      } else {
        this.moduletreeForm.Modules[index].Children[indexs].BrandCode = []
        this.moduletreeForm.Modules[index].Children[indexs].Authority = '0'
      }
    },
    isEnabledBrandCode (index, indexs, BrandCode) {
      if (BrandCode && BrandCode.length === 0) {
        this.moduletreeForm.Modules[index].Children[indexs].IsEnabled = false
        this.moduletreeForm.Modules[index].Children[indexs].Authority = '0'
      } else {
        this.moduletreeForm.Modules[index].Children[indexs].IsEnabled = true
        this.moduletreeForm.Modules[index].Children[indexs].Authority = '1'
      }
    },
    isEnabledAuthority (index, indexs, Authority) {
      this.moduletreeForm.Modules[index].Children[indexs].Authority = Authority
      if (!this.moduletreeForm.Modules[index].Children[indexs].IsEnabled) {
        this.moduletreeForm.Modules[index].Children[indexs].IsEnabled = true
      }
    }
  },
  created () {
    this.moduletreeForm.Modules.forEach(item => {
      item.Children.forEach(items => {
        if (items.Editable === true) {
          items.Authority = '2'
        } else {
          if (items.Readonly === true) {
            items.Authority = '1'
          } else {
            items.Authority = '0'
          }
        }
        if (items.BrandCode === null) {
          items.BrandCode = []
        }
      })
    })
    this.data.forEach(item => {
      this.expandArr.push(item.Id)
    })
  },
  model: {
    prop: 'moduletreeForm',
    event: 'moduletreeFormChange'
  },
  props: {
    data: {
      type: Array,
      requried: true
    },
    moduletreeForm: {
      type: Object,
      requried: true
    },
    brandList: {
      type: Array
    }
  }
}
</script>

<style scoped>
.brand_owner {
  margin-bottom: 10px;
}
.tree_expand_icon {
  display: inline-block;
  color: #c50f3c;
  transform: rotate(-90deg);
  transition: all 0.3s;
}
.item-enter-active {
  transition: all 0.4s;
}
.item-leave-active {
  transition: all 0s;
}
.item-enter,
.item-leave-to {
  opacity: 0;
}
input {
  outline: none;
}
input[type="checkbox"] {
  margin: 0 6px;
  -webkit-appearance: none;
  border: 1px solid #c50f3c;
  vertical-align: middle;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  transition: all 0.2s;
}
input[type="checkbox"]:checked {
  background-image: url("../../assets/img/checked.png");
  background-size: 100%;
  background-color: #c50f3c;
  transition: all 0.2s;
}
input[type="radio"] {
  margin: 0 6px;
  -webkit-appearance: none;
  border: 1px solid #c50f3c;
  vertical-align: middle;
  width: 18px;
  height: 18px;
  /* float: left; */
  border-radius: 50%;
  transition: all 0.2s;
}
input[type="radio"]:checked {
  transition: all 0.2s;
  background-image: url("../../assets/img/checked.png");
  background-size: 100%;
  background-color: #c50f3c;
}
span {
  font-size: 14px;
  color: #3d3d3d;
}
.content {
  padding: 12px 0px 0 18px;
}
.content_item {
  margin-bottom: 14px;
}
.content_item_item {
  margin-right: 20px;
  width: 30%;
}
.content_item_item span {
  display: inline-block;
  width: 80%;
  /*text-overflow: ellipsis;*/
  /*overflow: hidden;*/
  /*user-select: none;*/
  white-space: normal;
  word-break: break-word;
}
.content_item_item_item {
  width: 60%;
}
.content_item_item_item input {
  width: 14px;
  height: 14px;
}
.content_item_item_item label {
  margin: 0 12px 6px 0;
  font-size: 12px;
}
.radio_group {
  margin-right: 20px;
}
.radio {
  display: inline-block;
  margin: 0 6px;
}
.radio i {
  display: inline-block;
  width: 14px;
  height: 14px;
  font-size: 14px;
  border-radius: 50%;
  border: 1px solid #c50f3c;
  background-size: cover;
  box-sizing: border-box;
}
.radio_text {
  vertical-align: bottom;
  font-size: 12px;
}
.iconfont {
  color: #c50f3c;
}
.radio_active {
  background-color: #c50f3c;
  background-image: url("../../assets/img/checked.png");
}
</style>



// WEBPACK FOOTER //
// src/components/myComponents/tree.vue